import HttpRequest from './request'
import env from '@/env'
import { formatApi } from '@/api/ref'
import { getUserInfo, getCookie } from '@/utils/common'

// 服务请求地址
export const BASE_URL = env.baseUrl + '/lanqiao-tms-app/web'
export const TRADE_URL = env.baseUrl + '/lanqiao-tms-trade-app/web'

// 转化请求参数
export function toGetJavaParamsData (data: any, url: string) {
  let tmsversion = getCookie('TMSversion')
  if (['', 'C9BS', window.LQAPI.C9BS_CALL_CAR].indexOf(tmsversion) == -1) {
    tmsversion = 'CCBS'
  }
  let javanArr = url.split('?')[0].split('/')
  let javaN = javanArr[javanArr.length - 1]
  const params = {
    M: 'func', // 类型  Method
    N: javaN, // 过程名 Proc
    P: data || {}, // 过程参数 Par
    L: data.l || data.L || '', // 权限标识
    V: tmsversion, // 系统版本
    u: window.getNewUserInfo(),
    r: 'k',
    s: 'k',
    t: 1
  }

  return formatApi({ data: params })
}
export function fileDownLoad (params) {
  const fileRequest = new HttpRequest(params.isTradeApp ? TRADE_URL : BASE_URL)
  params.data = toGetJavaParamsData(params.data, params.url)
  params.method = params.method || 'post'
  params.responseType = 'blob'
  params.timeout = 3 * 60 * 1000 
  return fileRequest.request(params)
}

window.File_DownLoad_Api = fileDownLoad
